__turbopack_context__.v({
  "body": "styles-module__Y_Gncq__body",
  "head": "styles-module__Y_Gncq__head",
  "heading": "styles-module__Y_Gncq__heading",
  "inner": "styles-module__Y_Gncq__inner",
  "label": "styles-module__Y_Gncq__label",
  "note": "styles-module__Y_Gncq__note",
  "row": "styles-module__Y_Gncq__row",
  "rows": "styles-module__Y_Gncq__rows",
  "section": "styles-module__Y_Gncq__section",
});
